// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("/data/common/svg/chevron-right.svg", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `:root {
  --header-padding: 41px;
  --header-gap: 9px;
  --header-transform-y: -50px;
  --header-height: 40px;
  --font-size-normal: 16px;
  --font-size-small: 13px;
  --font-size-editor: 14px;
  /* Grep for media queries if changing */
  --page-max-width: 900px;
  --page-padding: 50px;
  --icon-size: 16px;
  --playback-bar-height: 77px;

  --button-border: #888;
  --button-background: #eee;
  --button-color: #000;
  --button-border-radius: 4px;
  --button-opacity: 0.9;
  --button-big-padding: 9px 15px;

  --modal-border-color: #ddd;
  --modal-background: #eee;
  --modal-shadow: 7px 6px 6px #0001;
  --modal-radius: 4px;

  /* active and focus rules for outside a div  (no layout is affected) */
  --outline-active: 2px solid #7c3aed;
  --outline-focus: 2px solid #7c3aedaa;
  --outline-focus-dim: 2px solid #7c3aed33;
  /* active and focus rules for inside a div (no layout is affected) */
  --box-shadow-active: 0 0 0 2px #7c3aed inset;
  --box-shadow-focus: 0 0 0 2px #7c3aedaa inset;

  /* One interactive accent — violet — across every surface. See AESTHETICS.md. */
  --accent: #7c3aed;
  --accent-strong: #5b28d6;
  --accent-tint: #7c3aed14;
  --accent-wash: #ece6fb;
  --line: #e6e6e6;
  --line-strong: #bbb;
  --font-display: 'Hanken Grotesk', system-ui, sans-serif;

  --ink: #111;
  --muted: #595959;
  --raised: #fafafa;
  --syntax-string: #0f5132;

  --accent-color: var(--accent);
  --accent-color-light: var(--accent-tint);

  --primary-color-dim: var(--accent);
  --primary-color: var(--accent);
  --primary-color-hover: #6d28d9;

  --selection-hover: #eee;
  --selection-active: var(--primary-color);
  --selection-active-hover: var(--primary-color-hover);
  --selection-inactive: #ccc;
  --selection-inactive-hover: #ddd;

  --text-border: #555;
  --light-border: #ddd;

  --success-color: #1e8e3e;
  --success-color-light: #1e8e3e1a;

  /* Animate elements reordering themselves. */
  --reorder-duration: 200ms;
  --reorder-easing: ease-out;
}

/**
 * "touch" and "mouse" have different density preferences for UI. By default use
 * the wider touch density. See :root[data-input-mode="mouse"]
 */
:root {
  & {
    --density-control-font-size: var(--font-size-normal);
    --density-control-padding: 6px;
    --density-font-size: var(--font-size-normal);
    --density-icon-padding: 4px;
    --density-icon-size: 20px;
    --density-menu-padding: 4px;
    --density-menu-radius: 16px;
    --density-row-padding: 8px;
    --density-touch-target: 44px;
  }

  &:root[data-input-mode="mouse"] {
    --density-control-font-size: var(--font-size-small);
    --density-control-padding: 4px;
    --density-font-size: var(--font-size-small);
    --density-icon-padding: 1px;
    --density-icon-size: 16px;
    --density-menu-padding: 2px;
    --density-menu-radius: 8px;
    --density-row-padding: 4px;
    --density-touch-target: 28px;
  }
}

/* animation: fadein 500ms; */
@keyframes fadein {
  from {
    opacity: 0;
  }
  to {
    opacity: 1;
  }
}

/* animation: fadeindelay 500ms; */
@keyframes fadeindelay {
  0% {
    opacity: 0;
  }
  30% {
    opacity: 0;
  }
  100% {
    opacity: 1;
  }
}

/*
  --slidedown-px: -20px;
  animation: slidedown 500ms;
*/
@keyframes slidedown {
  from {
    opacity: 0;
    transform: translateY(var(--slidedown-px));
  }
  to {
    opacity: 1;
    transform: translateY(0);
  }
}

html,
body,
.appContainer,
.appView {
  position: absolute;
  inset: 0;
}

body {
  margin: 0;
  font-family: system-ui, sans-serif;
  font-size: var(--font-size-normal);
}

a {
  color: var(--primary-color);
}

h1 {
  font-weight: 700;
}

h2 {
  font-weight: 650;
}

body {
  font-weight: 400;
}

.button,
.ͼ2 .cm-button {
  margin: 0;
  padding: 0.2em 0.5em;
  display: inline-block;
  border: 1px solid var(--button-border);
  color: var(--button-color);
  background-color: var(--button-background);
  border-radius: var(--button-border-radius);
  font-size: var(--font-size-small);
  cursor: pointer;
  opacity: var(--button-opacity);
  text-decoration: none;
  line-height: 1.2;
  font-family: system-ui, sans-serif;
}

button.icon {
  background-color: transparent;
}

button.icon,
button.icon-mask {
  border: none;
  padding: 0;
  margin: 0;
}

.button:active:not(:disabled),
.ͼ2 .cm-button:active:not(:disabled) {
  outline: var(--outline-active);
  z-index: 1;
}

.button:focus,
.ͼ2 .cm-button:focus {
  outline: var(--outline-focus);
}

.button:hover:not(:disabled),
.ͼ2 .cm-button:hover {
  opacity: 1;
}

.button:disabled,
.ͼ2 .cm-button:disabled {
  cursor: default;
  opacity: 0.6;
}

.ͼ1 span.cm-placeholder {
  color: #666;
}

.button-primary {
  border-color: var(--primary-color);
  background-color: var(--primary-color);
  color: #fff;
}

.button-primary:active:not(:disabled),
.button-primary:focus {
  border-color: #fff;
}

.missing-image {
  background: #fdd;
  display: inline-block;
  padding: 7px;
  border-radius: 5px;
}

code {
  padding: 0 4px;
  background-color: #eee;
  border-radius: 3px;
}

.centered {
  position: absolute;
  inset: var(--header-height) 0 0 0;
  display: flex;
  justify-content: center;
  align-items: center;
  flex-flow: column;
}

@media all and (display-mode: fullscreen) {
  [data-fullscreen] {
    background-color: #fff;
    margin: 0 auto;
    position: absolute;
    inset: 0;
    overflow-y: scroll;
  }
}

/**
 * Display a status to the user like "Download file failed" or "Loading file"
 */
.status {
  inset: var(--header-padding) 0 0 0;
  position: absolute;
  display: flex;
  justify-content: center;
  align-items: center;
  animation: fadein 1000ms;
}

.appView {
  padding-top: var(--header-padding);
}

/*
 * The music playback bar is position: fixed to the bottom of the viewport.
 * Reserving space here keeps it from covering the bottom of a view; views
 * sized off the viewport rather than .appView reserve their own (see
 * .listFiles). Only applied while something is playing.
 */
.appView-withPlaybackBar {
  padding-bottom: var(--playback-bar-height);
}

.appViewContents {
  position: relative; /* create a stacking context */
  flex: 1;
  overflow: hidden;
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 0; /* place this below the header */
}

.appViewError {
  width: calc(100% - 20px);
  height: 100%;
  position: absolute;
  margin: 10px;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  text-align: center;
}

.icon {
  display: inline-block;
  width: var(--icon-size);
  height: var(--icon-size);
  background-size: var(--icon-size) var(--icon-size);
}

.icon-mask {
  display: inline-block;
  width: var(--icon-size);
  height: var(--icon-size);
  background-color: currentColor;
  mask-size: var(--icon-size);
  color: inherit;
}

[data-icon='pencil'] {
  /* webpackIgnore: true */
  background-image: url('/svg/pencil.svg');
}

[data-icon='box-arrow-in-right'] {
  /* webpackIgnore: true */
  background-image: url('/svg/box-arrow-in-right.svg');
}

[data-icon='trash'] {
  /* webpackIgnore: true */
  background-image: url('/svg/trash.svg');
}

[data-icon='download'] {
  /* webpackIgnore: true */
  background-image: url('/svg/download.svg');
}

[data-icon-mask='play'] {
  /* webpackIgnore: true */
  mask-image: url('/svg/play.svg');
}

[data-icon-mask='pause'] {
  /* webpackIgnore: true */
  mask-image: url('/svg/pause.svg');
}

[data-icon='music'] {
  /* webpackIgnore: true */
  background-image: url('/svg/music.svg');
}
[data-icon='folder'] {
  /* webpackIgnore: true */
  background-image: url('/svg/folder.svg');
}
[data-icon='translate'] {
  /* webpackIgnore: true */
  background-image: url('/svg/translate.svg');
}
[data-icon='file-alt'] {
  /* webpackIgnore: true */
  background-image: url('/svg/file-alt.svg');
}
[data-icon='upload'] {
  /* webpackIgnore: true */
  background-image: url('/svg/upload.svg');
}

.renderedSong.dragging,
.viewMarkdown.dragging {
  opacity: 0.8;
}
.renderedSong.dragging::after,
.viewMarkdown.dragging::after {
  content: '';
  position: absolute;
  inset: 10px;
  border: 5px dashed #0070ff;
  border-radius: 30px;
  pointer-events: none;
}

@media print {
  .appView {
    padding: 0;
  }
}

/**
 * A re-usable error bar component.
 */
.error {
  background: #ffbfbf;
  padding: 15px;
  border-radius: 3px;
  border: 1px solid #f00;
  margin-bottom: 10px;
  width: 100%;
  font-size: var(--font-size-normal);
  box-sizing: border-box;
  display: flex;
  justify-content: space-between;

  & button {
    background: none;
    border: none;
    color: #721c24;
    font-size: 20px;
    font-weight: bold;
    cursor: pointer;
    padding: 10px;
    line-height: 1;
    display: flex;
    align-items: center;
    margin: -10px 0px;

    &:hover {
      color: #491217;
    }
  }
}

.disclosureChevron {
  background-color: currentColor;
  flex: 0 0 auto;
  height: 12px;
  margin-inline: 4px -2px;
  mask-image: url(${___CSS_LOADER_URL_REPLACEMENT_0___});
  mask-position: center;
  mask-repeat: no-repeat;
  mask-size: contain;
  transition: transform 120ms ease;
  width: 12px;

  [aria-expanded='true'] > & {
    transform: rotate(90deg);
  }
}

.page {
  width: 100%;
  justify-content: center;
  display: flex;
  line-height: 1.4;
}

.page .button {
  font-size: var(--font-size-normal);
  padding: 0.2em 0.5em;
}

.pageInner {
  width: 100%;
  margin: 40px;
  @media (max-width: 600px) {
    & {
      width: calc(100% - 30px);
    }
  }
}

.pageInner > h1:first-child,
.pageInner > h2:first-child,
.pageInner > h3:first-child,
.pageInner > h4:first-child {
  margin-top: 0;
}

@media (min-width: 900px) {
  .pageInner {
    max-width: var(--page-max-width);
  }
}
`, "",{"version":3,"sources":["webpack://./src/frontend/components/App.css"],"names":[],"mappings":"AAAA;EACE,sBAAsB;EACtB,iBAAiB;EACjB,2BAA2B;EAC3B,qBAAqB;EACrB,wBAAwB;EACxB,uBAAuB;EACvB,wBAAwB;EACxB,uCAAuC;EACvC,uBAAuB;EACvB,oBAAoB;EACpB,iBAAiB;EACjB,2BAA2B;;EAE3B,qBAAqB;EACrB,yBAAyB;EACzB,oBAAoB;EACpB,2BAA2B;EAC3B,qBAAqB;EACrB,8BAA8B;;EAE9B,0BAA0B;EAC1B,wBAAwB;EACxB,iCAAiC;EACjC,mBAAmB;;EAEnB,sEAAsE;EACtE,mCAAmC;EACnC,oCAAoC;EACpC,wCAAwC;EACxC,oEAAoE;EACpE,4CAA4C;EAC5C,6CAA6C;;EAE7C,+EAA+E;EAC/E,iBAAiB;EACjB,wBAAwB;EACxB,wBAAwB;EACxB,sBAAsB;EACtB,eAAe;EACf,mBAAmB;EACnB,uDAAuD;;EAEvD,WAAW;EACX,gBAAgB;EAChB,iBAAiB;EACjB,wBAAwB;;EAExB,6BAA6B;EAC7B,wCAAwC;;EAExC,kCAAkC;EAClC,8BAA8B;EAC9B,8BAA8B;;EAE9B,uBAAuB;EACvB,wCAAwC;EACxC,oDAAoD;EACpD,0BAA0B;EAC1B,gCAAgC;;EAEhC,mBAAmB;EACnB,oBAAoB;;EAEpB,wBAAwB;EACxB,gCAAgC;;EAEhC,4CAA4C;EAC5C,yBAAyB;EACzB,0BAA0B;AAC5B;;AAEA;;;EAGE;AACF;EACE;IACE,oDAAoD;IACpD,8BAA8B;IAC9B,4CAA4C;IAC5C,2BAA2B;IAC3B,yBAAyB;IACzB,2BAA2B;IAC3B,2BAA2B;IAC3B,0BAA0B;IAC1B,4BAA4B;EAC9B;;EAEA;IACE,mDAAmD;IACnD,8BAA8B;IAC9B,2CAA2C;IAC3C,2BAA2B;IAC3B,yBAAyB;IACzB,2BAA2B;IAC3B,0BAA0B;IAC1B,0BAA0B;IAC1B,4BAA4B;EAC9B;AACF;;AAEA,6BAA6B;AAC7B;EACE;IACE,UAAU;EACZ;EACA;IACE,UAAU;EACZ;AACF;;AAEA,kCAAkC;AAClC;EACE;IACE,UAAU;EACZ;EACA;IACE,UAAU;EACZ;EACA;IACE,UAAU;EACZ;AACF;;AAEA;;;CAGC;AACD;EACE;IACE,UAAU;IACV,0CAA0C;EAC5C;EACA;IACE,UAAU;IACV,wBAAwB;EAC1B;AACF;;AAEA;;;;EAIE,kBAAkB;EAClB,QAAQ;AACV;;AAEA;EACE,SAAS;EACT,kCAAkC;EAClC,kCAAkC;AACpC;;AAEA;EACE,2BAA2B;AAC7B;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;;EAEE,SAAS;EACT,oBAAoB;EACpB,qBAAqB;EACrB,sCAAsC;EACtC,0BAA0B;EAC1B,0CAA0C;EAC1C,0CAA0C;EAC1C,iCAAiC;EACjC,eAAe;EACf,8BAA8B;EAC9B,qBAAqB;EACrB,gBAAgB;EAChB,kCAAkC;AACpC;;AAEA;EACE,6BAA6B;AAC/B;;AAEA;;EAEE,YAAY;EACZ,UAAU;EACV,SAAS;AACX;;AAEA;;EAEE,8BAA8B;EAC9B,UAAU;AACZ;;AAEA;;EAEE,6BAA6B;AAC/B;;AAEA;;EAEE,UAAU;AACZ;;AAEA;;EAEE,eAAe;EACf,YAAY;AACd;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,kCAAkC;EAClC,sCAAsC;EACtC,WAAW;AACb;;AAEA;;EAEE,kBAAkB;AACpB;;AAEA;EACE,gBAAgB;EAChB,qBAAqB;EACrB,YAAY;EACZ,kBAAkB;AACpB;;AAEA;EACE,cAAc;EACd,sBAAsB;EACtB,kBAAkB;AACpB;;AAEA;EACE,kBAAkB;EAClB,iCAAiC;EACjC,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,iBAAiB;AACnB;;AAEA;EACE;IACE,sBAAsB;IACtB,cAAc;IACd,kBAAkB;IAClB,QAAQ;IACR,kBAAkB;EACpB;AACF;;AAEA;;EAEE;AACF;EACE,kCAAkC;EAClC,kBAAkB;EAClB,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,wBAAwB;AAC1B;;AAEA;EACE,kCAAkC;AACpC;;AAEA;;;;;EAKE;AACF;EACE,0CAA0C;AAC5C;;AAEA;EACE,kBAAkB,EAAE,8BAA8B;EAClD,OAAO;EACP,gBAAgB;EAChB,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,UAAU,EAAE,gCAAgC;AAC9C;;AAEA;EACE,wBAAwB;EACxB,YAAY;EACZ,kBAAkB;EAClB,YAAY;EACZ,aAAa;EACb,sBAAsB;EACtB,uBAAuB;EACvB,mBAAmB;EACnB,kBAAkB;AACpB;;AAEA;EACE,qBAAqB;EACrB,uBAAuB;EACvB,wBAAwB;EACxB,kDAAkD;AACpD;;AAEA;EACE,qBAAqB;EACrB,uBAAuB;EACvB,wBAAwB;EACxB,8BAA8B;EAC9B,2BAA2B;EAC3B,cAAc;AAChB;;AAEA;EACE,wBAAwB;EACxB,wCAAwC;AAC1C;;AAEA;EACE,wBAAwB;EACxB,oDAAoD;AACtD;;AAEA;EACE,wBAAwB;EACxB,uCAAuC;AACzC;;AAEA;EACE,wBAAwB;EACxB,0CAA0C;AAC5C;;AAEA;EACE,wBAAwB;EACxB,gCAAgC;AAClC;;AAEA;EACE,wBAAwB;EACxB,iCAAiC;AACnC;;AAEA;EACE,wBAAwB;EACxB,uCAAuC;AACzC;AACA;EACE,wBAAwB;EACxB,wCAAwC;AAC1C;AACA;EACE,wBAAwB;EACxB,2CAA2C;AAC7C;AACA;EACE,wBAAwB;EACxB,0CAA0C;AAC5C;AACA;EACE,wBAAwB;EACxB,wCAAwC;AAC1C;;AAEA;;EAEE,YAAY;AACd;AACA;;EAEE,WAAW;EACX,kBAAkB;EAClB,WAAW;EACX,0BAA0B;EAC1B,mBAAmB;EACnB,oBAAoB;AACtB;;AAEA;EACE;IACE,UAAU;EACZ;AACF;;AAEA;;EAEE;AACF;EACE,mBAAmB;EACnB,aAAa;EACb,kBAAkB;EAClB,sBAAsB;EACtB,mBAAmB;EACnB,WAAW;EACX,kCAAkC;EAClC,sBAAsB;EACtB,aAAa;EACb,8BAA8B;;EAE9B;IACE,gBAAgB;IAChB,YAAY;IACZ,cAAc;IACd,eAAe;IACf,iBAAiB;IACjB,eAAe;IACf,aAAa;IACb,cAAc;IACd,aAAa;IACb,mBAAmB;IACnB,iBAAiB;;IAEjB;MACE,cAAc;IAChB;EACF;AACF;;AAEA;EACE,8BAA8B;EAC9B,cAAc;EACd,YAAY;EACZ,uBAAuB;EACvB,mDAAqD;EACrD,qBAAqB;EACrB,sBAAsB;EACtB,kBAAkB;EAClB,gCAAgC;EAChC,WAAW;;EAEX;IACE,wBAAwB;EAC1B;AACF;;AAEA;EACE,WAAW;EACX,uBAAuB;EACvB,aAAa;EACb,gBAAgB;AAClB;;AAEA;EACE,kCAAkC;EAClC,oBAAoB;AACtB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ;IACE;MACE,wBAAwB;IAC1B;EACF;AACF;;AAEA;;;;EAIE,aAAa;AACf;;AAEA;EACE;IACE,gCAAgC;EAClC;AACF","sourcesContent":[":root {\n  --header-padding: 41px;\n  --header-gap: 9px;\n  --header-transform-y: -50px;\n  --header-height: 40px;\n  --font-size-normal: 16px;\n  --font-size-small: 13px;\n  --font-size-editor: 14px;\n  /* Grep for media queries if changing */\n  --page-max-width: 900px;\n  --page-padding: 50px;\n  --icon-size: 16px;\n  --playback-bar-height: 77px;\n\n  --button-border: #888;\n  --button-background: #eee;\n  --button-color: #000;\n  --button-border-radius: 4px;\n  --button-opacity: 0.9;\n  --button-big-padding: 9px 15px;\n\n  --modal-border-color: #ddd;\n  --modal-background: #eee;\n  --modal-shadow: 7px 6px 6px #0001;\n  --modal-radius: 4px;\n\n  /* active and focus rules for outside a div  (no layout is affected) */\n  --outline-active: 2px solid #7c3aed;\n  --outline-focus: 2px solid #7c3aedaa;\n  --outline-focus-dim: 2px solid #7c3aed33;\n  /* active and focus rules for inside a div (no layout is affected) */\n  --box-shadow-active: 0 0 0 2px #7c3aed inset;\n  --box-shadow-focus: 0 0 0 2px #7c3aedaa inset;\n\n  /* One interactive accent — violet — across every surface. See AESTHETICS.md. */\n  --accent: #7c3aed;\n  --accent-strong: #5b28d6;\n  --accent-tint: #7c3aed14;\n  --accent-wash: #ece6fb;\n  --line: #e6e6e6;\n  --line-strong: #bbb;\n  --font-display: 'Hanken Grotesk', system-ui, sans-serif;\n\n  --ink: #111;\n  --muted: #595959;\n  --raised: #fafafa;\n  --syntax-string: #0f5132;\n\n  --accent-color: var(--accent);\n  --accent-color-light: var(--accent-tint);\n\n  --primary-color-dim: var(--accent);\n  --primary-color: var(--accent);\n  --primary-color-hover: #6d28d9;\n\n  --selection-hover: #eee;\n  --selection-active: var(--primary-color);\n  --selection-active-hover: var(--primary-color-hover);\n  --selection-inactive: #ccc;\n  --selection-inactive-hover: #ddd;\n\n  --text-border: #555;\n  --light-border: #ddd;\n\n  --success-color: #1e8e3e;\n  --success-color-light: #1e8e3e1a;\n\n  /* Animate elements reordering themselves. */\n  --reorder-duration: 200ms;\n  --reorder-easing: ease-out;\n}\n\n/**\n * \"touch\" and \"mouse\" have different density preferences for UI. By default use\n * the wider touch density. See :root[data-input-mode=\"mouse\"]\n */\n:root {\n  & {\n    --density-control-font-size: var(--font-size-normal);\n    --density-control-padding: 6px;\n    --density-font-size: var(--font-size-normal);\n    --density-icon-padding: 4px;\n    --density-icon-size: 20px;\n    --density-menu-padding: 4px;\n    --density-menu-radius: 16px;\n    --density-row-padding: 8px;\n    --density-touch-target: 44px;\n  }\n\n  &:root[data-input-mode=\"mouse\"] {\n    --density-control-font-size: var(--font-size-small);\n    --density-control-padding: 4px;\n    --density-font-size: var(--font-size-small);\n    --density-icon-padding: 1px;\n    --density-icon-size: 16px;\n    --density-menu-padding: 2px;\n    --density-menu-radius: 8px;\n    --density-row-padding: 4px;\n    --density-touch-target: 28px;\n  }\n}\n\n/* animation: fadein 500ms; */\n@keyframes fadein {\n  from {\n    opacity: 0;\n  }\n  to {\n    opacity: 1;\n  }\n}\n\n/* animation: fadeindelay 500ms; */\n@keyframes fadeindelay {\n  0% {\n    opacity: 0;\n  }\n  30% {\n    opacity: 0;\n  }\n  100% {\n    opacity: 1;\n  }\n}\n\n/*\n  --slidedown-px: -20px;\n  animation: slidedown 500ms;\n*/\n@keyframes slidedown {\n  from {\n    opacity: 0;\n    transform: translateY(var(--slidedown-px));\n  }\n  to {\n    opacity: 1;\n    transform: translateY(0);\n  }\n}\n\nhtml,\nbody,\n.appContainer,\n.appView {\n  position: absolute;\n  inset: 0;\n}\n\nbody {\n  margin: 0;\n  font-family: system-ui, sans-serif;\n  font-size: var(--font-size-normal);\n}\n\na {\n  color: var(--primary-color);\n}\n\nh1 {\n  font-weight: 700;\n}\n\nh2 {\n  font-weight: 650;\n}\n\nbody {\n  font-weight: 400;\n}\n\n.button,\n.ͼ2 .cm-button {\n  margin: 0;\n  padding: 0.2em 0.5em;\n  display: inline-block;\n  border: 1px solid var(--button-border);\n  color: var(--button-color);\n  background-color: var(--button-background);\n  border-radius: var(--button-border-radius);\n  font-size: var(--font-size-small);\n  cursor: pointer;\n  opacity: var(--button-opacity);\n  text-decoration: none;\n  line-height: 1.2;\n  font-family: system-ui, sans-serif;\n}\n\nbutton.icon {\n  background-color: transparent;\n}\n\nbutton.icon,\nbutton.icon-mask {\n  border: none;\n  padding: 0;\n  margin: 0;\n}\n\n.button:active:not(:disabled),\n.ͼ2 .cm-button:active:not(:disabled) {\n  outline: var(--outline-active);\n  z-index: 1;\n}\n\n.button:focus,\n.ͼ2 .cm-button:focus {\n  outline: var(--outline-focus);\n}\n\n.button:hover:not(:disabled),\n.ͼ2 .cm-button:hover {\n  opacity: 1;\n}\n\n.button:disabled,\n.ͼ2 .cm-button:disabled {\n  cursor: default;\n  opacity: 0.6;\n}\n\n.ͼ1 span.cm-placeholder {\n  color: #666;\n}\n\n.button-primary {\n  border-color: var(--primary-color);\n  background-color: var(--primary-color);\n  color: #fff;\n}\n\n.button-primary:active:not(:disabled),\n.button-primary:focus {\n  border-color: #fff;\n}\n\n.missing-image {\n  background: #fdd;\n  display: inline-block;\n  padding: 7px;\n  border-radius: 5px;\n}\n\ncode {\n  padding: 0 4px;\n  background-color: #eee;\n  border-radius: 3px;\n}\n\n.centered {\n  position: absolute;\n  inset: var(--header-height) 0 0 0;\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  flex-flow: column;\n}\n\n@media all and (display-mode: fullscreen) {\n  [data-fullscreen] {\n    background-color: #fff;\n    margin: 0 auto;\n    position: absolute;\n    inset: 0;\n    overflow-y: scroll;\n  }\n}\n\n/**\n * Display a status to the user like \"Download file failed\" or \"Loading file\"\n */\n.status {\n  inset: var(--header-padding) 0 0 0;\n  position: absolute;\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  animation: fadein 1000ms;\n}\n\n.appView {\n  padding-top: var(--header-padding);\n}\n\n/*\n * The music playback bar is position: fixed to the bottom of the viewport.\n * Reserving space here keeps it from covering the bottom of a view; views\n * sized off the viewport rather than .appView reserve their own (see\n * .listFiles). Only applied while something is playing.\n */\n.appView-withPlaybackBar {\n  padding-bottom: var(--playback-bar-height);\n}\n\n.appViewContents {\n  position: relative; /* create a stacking context */\n  flex: 1;\n  overflow: hidden;\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  z-index: 0; /* place this below the header */\n}\n\n.appViewError {\n  width: calc(100% - 20px);\n  height: 100%;\n  position: absolute;\n  margin: 10px;\n  display: flex;\n  flex-direction: column;\n  justify-content: center;\n  align-items: center;\n  text-align: center;\n}\n\n.icon {\n  display: inline-block;\n  width: var(--icon-size);\n  height: var(--icon-size);\n  background-size: var(--icon-size) var(--icon-size);\n}\n\n.icon-mask {\n  display: inline-block;\n  width: var(--icon-size);\n  height: var(--icon-size);\n  background-color: currentColor;\n  mask-size: var(--icon-size);\n  color: inherit;\n}\n\n[data-icon='pencil'] {\n  /* webpackIgnore: true */\n  background-image: url('/svg/pencil.svg');\n}\n\n[data-icon='box-arrow-in-right'] {\n  /* webpackIgnore: true */\n  background-image: url('/svg/box-arrow-in-right.svg');\n}\n\n[data-icon='trash'] {\n  /* webpackIgnore: true */\n  background-image: url('/svg/trash.svg');\n}\n\n[data-icon='download'] {\n  /* webpackIgnore: true */\n  background-image: url('/svg/download.svg');\n}\n\n[data-icon-mask='play'] {\n  /* webpackIgnore: true */\n  mask-image: url('/svg/play.svg');\n}\n\n[data-icon-mask='pause'] {\n  /* webpackIgnore: true */\n  mask-image: url('/svg/pause.svg');\n}\n\n[data-icon='music'] {\n  /* webpackIgnore: true */\n  background-image: url('/svg/music.svg');\n}\n[data-icon='folder'] {\n  /* webpackIgnore: true */\n  background-image: url('/svg/folder.svg');\n}\n[data-icon='translate'] {\n  /* webpackIgnore: true */\n  background-image: url('/svg/translate.svg');\n}\n[data-icon='file-alt'] {\n  /* webpackIgnore: true */\n  background-image: url('/svg/file-alt.svg');\n}\n[data-icon='upload'] {\n  /* webpackIgnore: true */\n  background-image: url('/svg/upload.svg');\n}\n\n.renderedSong.dragging,\n.viewMarkdown.dragging {\n  opacity: 0.8;\n}\n.renderedSong.dragging::after,\n.viewMarkdown.dragging::after {\n  content: '';\n  position: absolute;\n  inset: 10px;\n  border: 5px dashed #0070ff;\n  border-radius: 30px;\n  pointer-events: none;\n}\n\n@media print {\n  .appView {\n    padding: 0;\n  }\n}\n\n/**\n * A re-usable error bar component.\n */\n.error {\n  background: #ffbfbf;\n  padding: 15px;\n  border-radius: 3px;\n  border: 1px solid #f00;\n  margin-bottom: 10px;\n  width: 100%;\n  font-size: var(--font-size-normal);\n  box-sizing: border-box;\n  display: flex;\n  justify-content: space-between;\n\n  & button {\n    background: none;\n    border: none;\n    color: #721c24;\n    font-size: 20px;\n    font-weight: bold;\n    cursor: pointer;\n    padding: 10px;\n    line-height: 1;\n    display: flex;\n    align-items: center;\n    margin: -10px 0px;\n\n    &:hover {\n      color: #491217;\n    }\n  }\n}\n\n.disclosureChevron {\n  background-color: currentColor;\n  flex: 0 0 auto;\n  height: 12px;\n  margin-inline: 4px -2px;\n  mask-image: url('/data/common/svg/chevron-right.svg');\n  mask-position: center;\n  mask-repeat: no-repeat;\n  mask-size: contain;\n  transition: transform 120ms ease;\n  width: 12px;\n\n  [aria-expanded='true'] > & {\n    transform: rotate(90deg);\n  }\n}\n\n.page {\n  width: 100%;\n  justify-content: center;\n  display: flex;\n  line-height: 1.4;\n}\n\n.page .button {\n  font-size: var(--font-size-normal);\n  padding: 0.2em 0.5em;\n}\n\n.pageInner {\n  width: 100%;\n  margin: 40px;\n  @media (max-width: 600px) {\n    & {\n      width: calc(100% - 30px);\n    }\n  }\n}\n\n.pageInner > h1:first-child,\n.pageInner > h2:first-child,\n.pageInner > h3:first-child,\n.pageInner > h4:first-child {\n  margin-top: 0;\n}\n\n@media (min-width: 900px) {\n  .pageInner {\n    max-width: var(--page-max-width);\n  }\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
